import Image from 'next/image';

import { Box, Link, List, ListItem, Text } from '@chakra-ui/react';

import { trackEvent } from '~/features/analytics/track-event';
import { useBaseUrl } from '~/hooks/use-base-url';

export function CaseStudySocialLinks() {
  const shareUrl = useBaseUrl();
  const twitterShareText = 'Check out this case study from Udacity!';
  const hashtags = ['udacity', 'casestudy'].join(',');

  const socialMediaLinks = [
    {
      id: 'facebook',
      iconSrc: '/images/social/facebook-dark.svg',
      href: `https://www.facebook.com/sharer/sharer.php?display=popup&u=${shareUrl}`,
      label: 'Share on Facebook',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - Facebook',
          action: 'share_case_study_clicked',
        }),
    },
    {
      id: 'twitter',
      iconSrc: '/images/social/x-dark.svg',
      href: `https://twitter.com/intent/tweet?text=${twitterShareText}&url=${shareUrl}&hashtags=${hashtags}`,
      label: 'Share on X',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - Twitter',
          action: 'share_case_study_clicked',
        }),
    },
    {
      id: 'linkedin',
      iconSrc: '/images/social/linkedin-dark.svg',
      href: `http://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
      label: 'Share on LinkedIn',
      track: () =>
        trackEvent({
          type: 'click',
          name: 'Enterprise CTA Clicked',
          label: 'Share This Case Study - LinkedIn',
          action: 'share_case_study_clicked',
        }),
    },
  ];
  return (
    <Box alignItems='center' display='flex' flexWrap={{ base: 'wrap', md: 'nowrap' }} justifyContent='center'>
      <Text>Share this case study</Text>

      <List
        display='flex'
        gap='8px'
        justifyContent='center'
        marginLeft={{ base: '0', md: '48px' }}
        marginTop={{ base: '24px', md: '0' }}
        sx={{ '> li:not(:first-child)': { marginLeft: '32px' } }}
        width={{ base: '100%', md: 'auto' }}
      >
        {socialMediaLinks.map((link) => (
          <ListItem key={link.id} onClick={link.track}>
            <Link href={link.href} isExternal={true}>
              <Image alt={link.label} height={32} src={link.iconSrc} width={32} />
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
